// extracted by mini-css-extract-plugin
module.exports = {"container":"SummaryContainer_container__EtBZm","headline":"SummaryContainer_headline__erXAu","lines":"SummaryContainer_lines__V1AW0"};